import { FC } from 'react'

const Logout: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '25'}
      height={height || '24'}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M17.167 8L15.757 9.41L17.337 11H9.16699V13H17.337L15.757 14.58L17.167 16L21.167 12L17.167 8ZM5.16699 5H12.167V3H5.16699C4.06699 3 3.16699 3.9 3.16699 5V19C3.16699 20.1 4.06699 21 5.16699 21H12.167V19H5.16699V5Z'
        fill={fill || '#1D1D1F'}
      />
    </svg>
  )
}

export default Logout
